import { SupplierAnalyticsDashboard } from "@/components/SupplierAnalyticsDashboard";

export default function SupplierAnalytics() {
  return <SupplierAnalyticsDashboard />;
}